<template>
    <div class="account-panel">
        <div class="user">
            <img alt="User" :src="$hisport.absolute(me.logo, {default:'/images/user_default.png', w: 64})"> 
            <span>{{me.name}}</span>
        </div>
        <ul>
            <li>
                <font-awesome-icon :icon="['fas','edit']" />
                <router-link :to="'/users/' + me.id + '/edit?return_url=/'" v-i18n="'USER_EDIT'" />
            </li>
            <li>
                <font-awesome-icon :icon="['fas','key']" />
                <router-link to="/account/change-password" v-i18n="'CHANGE_PASSWORD'" />
            </li>
            <li>
                <font-awesome-icon :icon="['fas','sign-out-alt']" />
                <a href="javascript: void 0" @click="logout" v-i18n="'LOGOUT'"/>
            </li>
            <li></li>
            <li class="alert">
                <font-awesome-icon :icon="['fas','radiation-alt']" />
                <router-link to="/account/close" v-i18n="'CLOSE_ACCOUNT'" />
            </li>
        </ul>
    </div>
</template>
<style scoped>
.account-panel{
    padding-top:50px;
}
.account-panel .user{
    display:flex;
    color: var(--white);
    justify-content: space-around;
    background:rgba(255,255,255,.5);
    padding:20px 0;
}
.account-panel .user img{
    width:100px!important;
    margin:0 10px;
}
.account-panel .user span{
    font-weight: bold;
    font-size:30px;
    text-align:left;
    line-height: 30px;
    margin:20px 10px;
}
.account-panel a{
    text-decoration: none;
    color:var(--dark-grey);
}
.account-panel ul{
    list-style-type: none;
    text-align:left;
    margin:20px 10px;
    padding:0;
    height:calc(100vh - 150px);
}
.account-panel li{
    display:block;
    height:40px;
    font-weight:bold;
    font-size:16px;
    padding:5px;
    border-radius:var(--border-radius);
    color:#fff;
}
.account-panel li a{
    color:inherit;
    margin-left:10px;
}
.account-panel li.alert{
    color: var(--hg-red);
}
</style>
<script>
export default {
    title: "Account",
  methods:{
    logout: function(){
      var self = this;
      this.$hisport.datacontext.auth.logout()
        .then(function(){
            self.$store.dispatch("logoutSuccess");
            self.$router.push("/login");
            localStorage.clear()
        })
        .catch(function(error){
            alert("ERROR " + error)
        })
    }
  },
  computed: {
    me: function(){
      return this.$store.getters['loggedUser'];
    }
  }
}
</script>